import React, { useEffect } from "react";
import { colors } from "../../constants/theme";
import { useState } from "react";
import { services } from "../../constants/data";

const ServicesContainer = ({ slug }) => {
  const [item, setItem] = useState(null);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    const temp = services.find((item) => item.slug === slug);
    setItem(temp);
  }, [slug]);
  useEffect(() => {
    // const tempActive = item?.menu_items?.find((item) => item.title === item[0].title);
    setActiveItem(item?.menu_items[0]);
  }, [item]);
  return (
    <>
      {item ? (
        <div>
          <div
            style={{ backgroundImage: `url(${item?.bgImg})` }}
            className="w-full pt-32 pb-14 px-10 md:px-24"
          >
            <div className="h-[15px] w-[80px] bg-pink-600 my-2" />
            <h1 className="uppercase font-normal text-2xl text-white">
              {item.header}
            </h1>
          </div>
          {/* COntent */}
          <div className="grid grid-cols-1 md:grid-cols-3 md:space-x-16 max-w-[1240px] lg:mx-32 md:mx-32 mx-10 py-10 md:py-10">
            {/* Description */}
            <div className="my-2 py-5" style={{}}>
              <div className="flex items-center">
                <h1
                  style={{ color: colors.blueColor }}
                  className="uppercase font-medium text-2xl mr-6"
                >
                  {item?.header}
                </h1>
              </div>
              <div>
                <p className="font-light text-black text-sm text-left mt-8">
                  {item?.content1}
                </p>
                <p className="font-light text-black text-sm text-left mt-8">
                  {item?.content2}
                </p>
              </div>
            </div>
            {/* Image */}
            <div className=" col-span-2 my-2 py-10 px-4 relative">
              <img src={item?.imgUrl} alt="Products" />
            </div>
          </div>
          {/* Line */}
          <div
            style={{ background: colors.blueColor }}
            className="h-[0.5px] md:w-[400px] w-full my-10 mb-10 md:mx-auto"
          />
          {/* Bottom Button */}
          <div className="md:mx-36 flex justify-center items-center flex-wrap mb-14">
            {item?.menu_items?.map((i, index) => (
              <div
                key={index}
                className={`flex items-center justify-center uppercase md:text-lg text-md py-8 md:w-[250px] w-[150px] md:h-[100px] h-[60px] border border-white text-center px-4 cursor-pointer hover:bg-blue-900 hover:text-white  ${
                  i?.title === activeItem?.title
                    ? " bg-blue-900 text-white"
                    : " bg-zinc-100 text-black font-light"
                }`}
                onClick={() => {
                  setActiveItem(i);
                }}
              >
                {i?.title}
              </div>
            ))}
          </div>
          {/* Line */}
          <div
            style={{ background: colors.blueColor }}
            className="h-[0.5px] md:w-[400px] w-full my-10 md:mx-auto"
          />
          {activeItem && (
            <div className="bg-zinc-100 md:mx-64 my-20 md:px-20 px-10 py-10">
              {/* Sub Header */}
              <h1 className="uppercase text-blue-900 font-bold py-5">
                {activeItem?.title}
              </h1>
              <p className="text-[14px] font-light text-left">
                {activeItem?.desc}
              </p>
            </div>
          )}
        </div>
      ) : (
        <div />
      )}
    </>
  );
};

export default ServicesContainer;
